import { token, logout as logoutRequest } from "@/api/auth";
import { me } from "@/api/me";
import { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: null,
    name: "",
    username: "",
    firstName: "",
    lastName: "",
    mediaUrl: "",
    siteUrl: "",
    roles: [],
    regions: null,
    regionsName: null,
    passwordExpiredAt: null,
    daysBeforePasswordExpires: null,
    mustChangePassword: false,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_USERNAME: (state, username) => {
    state.username = username;
  },
  SET_FIRST_NAME: (state, firstName) => {
    state.firstName = firstName;
  },
  SET_LAST_NAME: (state, lastName) => {
    state.lastName = lastName;
  },
  SET_MEDIA_URL: (state, mediaUrl) => {
    state.mediaUrl = mediaUrl;
  },
  SET_SITE_URL: (state, siteUrl) => {
    state.siteUrl = siteUrl;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_REGIONS: (state, regions) => {
    state.regions = regions;
  },
  SET_REGIONS_NAME: (state, regionsName) => {
    state.regionsName = regionsName;
  },
  SET_PASSWORD_EXPIRED_AT: (state, passwordExpiredAt) => {
    state.passwordExpiredAt = passwordExpiredAt;
  },
  SET_DAYS_BEFORE_PASSWORD_EXPIRES: (state, daysBeforePasswordExpires) => {
    state.daysBeforePasswordExpires = daysBeforePasswordExpires;
  },
  SET_MUST_CHANGE_PASSWORD: (state, mustChangePassword) => {
    state.mustChangePassword = !!mustChangePassword;
  },
};

const actions = {
  // user login
  login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      token(payload)
        .then((resp) => {
          const accessToken = resp.access_token;
          commit("SET_TOKEN", accessToken || null);

          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit }, options = {}) {
    return new Promise((resolve, reject) => {
      // skipRefresh — пред-авторизационная проба (например, проверка сессии
      // на /login): её 401 не должен провоцировать обновление токена.
      me(undefined, options.skipRefresh ? { _skipRefresh: true } : {})
        .then((resp) => {
          commit("SET_NAME", resp.name);
          commit("SET_USERNAME", resp.username);
          commit("SET_ROLES", Array.isArray(resp.roles) ? resp.roles : []);
          commit("SET_REGIONS", Object.keys(resp.regions || {}));
          commit("SET_REGIONS_NAME", resp.regions);
          commit("SET_PASSWORD_EXPIRED_AT", resp.password_expired_at);
          commit(
            "SET_DAYS_BEFORE_PASSWORD_EXPIRES",
            resp.days_before_password_expires
          );
          commit("SET_MUST_CHANGE_PASSWORD", resp.must_change_password);
          resolve(resp);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit }) {
    return new Promise((resolve) => {
      logoutRequest()
        .catch(() => {
          // Даже при ошибке logout-эндпоинта локальное состояние нужно сбросить.
        })
        .finally(() => {
          resetRouter();

          commit("SET_NAME", "");
          commit("SET_USERNAME", "");
          commit("SET_REGIONS", null);
          commit("SET_PASSWORD_EXPIRED_AT", null);
          commit("SET_DAYS_BEFORE_PASSWORD_EXPIRES", null);
          commit("SET_MUST_CHANGE_PASSWORD", false);
          commit("RESET_STATE");
          resolve();
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
